import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingTop: 70,
  },

  bg: {
    width: "100%",
    height: "100vh",
    background: theme.colors.Background1,
  },

  header: {
    background: "#0E1A2A",
  },

  content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },

  juspayCheckout: {
    width: "100%",
    height: "100%",
    "&.space": {
      marginTop: 56,
    },
  },

  iframeContainer: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },

  iframeHeader: {
    padding: `${theme.spacing.space12}px ${theme.spacing.space16}px`,
  },

  iframeCloseButton: {
    background: "none",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    fontSize: 20,
  },

  iframe: {
    flex: 1,
    border: "none",
    width: "100%",
  },

  loadingOverlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
